export const SET_NOTIFICATIONS_DATA = 'SET_NOTIFICATIONS_DATA';
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';